"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenShiftVersionDropdown = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const formik_1 = require("formik");
const formik_2 = require("./formik");
const ExternalLink_1 = tslib_1.__importDefault(require("./ExternalLink"));
const config_1 = require("../../config");
const getParsedVersions = (items) => {
    const versionsY = Array.from(new Set(items.map((val) => { var _a; return (_a = val.value.match(/^\d+\.(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]; })));
    const parsedVersions = versionsY.map((y) => ({
        y: y,
        versions: items.filter((val) => { var _a; return ((_a = val.value.match(/^\d+\.(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]) === y; }),
    }));
    return { parsedVersions: parsedVersions.reverse() };
};
const OpenShiftVersionDropdown = ({ name, items, versions, getHelperText, showReleasesLink, showOpenshiftVersionModal, customItems, }) => {
    const [field, , { setValue }] = (0, formik_1.useField)(name);
    const [isOpen, setOpen] = react_1.default.useState(false);
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    const fieldId = (0, formik_2.getFieldId)(name, 'input');
    const isDisabled = versions.length === 0;
    const { values: { customOpenshiftSelect }, } = (0, formik_1.useFormikContext)();
    const [current, setCurrent] = react_1.default.useState();
    react_1.default.useEffect(() => {
        const defaultVersion = customOpenshiftSelect
            ? customOpenshiftSelect
            : versions.find((item) => item.default);
        setCurrent((defaultVersion === null || defaultVersion === void 0 ? void 0 : defaultVersion.label) || '');
        setValue((defaultVersion === null || defaultVersion === void 0 ? void 0 : defaultVersion.value) || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customOpenshiftSelect]);
    const parsedVersionsForItems = getParsedVersions(items);
    let lastY = '';
    const dropdownItems = parsedVersionsForItems.parsedVersions.map(({ y, versions }) => {
        const items = versions.map(({ value, label }) => (react_1.default.createElement(react_core_1.DropdownItem, { key: value, id: value, value: value }, label)));
        if (lastY !== null && y !== lastY) {
            items.push(react_1.default.createElement(react_core_1.Divider, { key: `separator-${y || ''}` }));
        }
        lastY = y;
        return items;
    });
    const parsedVersionsForCustomItems = getParsedVersions(customItems);
    let lastCustomY = '';
    const customDropdownItems = parsedVersionsForCustomItems.parsedVersions.map(({ y, versions }) => {
        const customItems = versions.map(({ value, label }) => (react_1.default.createElement(react_core_1.DropdownItem, { key: value, id: value, value: value }, label)));
        if (lastCustomY !== null && y !== lastCustomY) {
            customItems.push(react_1.default.createElement(react_core_1.Divider, { key: `separator-${y || ''}` }));
        }
        lastCustomY = y;
        return customItems;
    });
    const dropdownGroup = [
        dropdownItems.length && (react_1.default.createElement(react_core_1.DropdownGroup, { label: "Latest releases", key: "latest-releases" }, dropdownItems)),
        react_1.default.createElement(react_core_1.DropdownGroup, { label: "Custom releases", key: "custom-releases" }, customDropdownItems),
        react_1.default.createElement(react_core_1.DropdownGroup, { key: "all-available-versions" },
            react_1.default.createElement(react_core_1.DropdownItem, { key: "all-versions", id: "all-versions" },
                react_1.default.createElement(react_core_1.Button, { variant: "link", isInline: true, onClick: () => showOpenshiftVersionModal(), id: "show-all-versions" }, "Show all available versions"))),
    ];
    const onSelect = react_1.default.useCallback((event, val) => {
        const newLabel = event === null || event === void 0 ? void 0 : event.currentTarget.textContent;
        const newValue = val || '';
        if (newLabel && newValue !== 'all-versions') {
            setCurrent(newLabel);
            setValue(newValue);
            setOpen(false);
        }
    }, [setValue]);
    const dropdownToggle = (toggleRef) => (react_1.default.createElement(react_core_1.MenuToggle, { id: fieldId, className: "pf-v5-u-w-100", ref: toggleRef, isFullWidth: true, onClick: () => setOpen(!isOpen), isDisabled: isDisabled, isExpanded: isOpen }, current));
    const helperText = getHelperText && getHelperText(field.value);
    return (react_1.default.createElement(react_core_1.FormGroup, { id: `form-control__${fieldId}`, fieldId: fieldId, label: t('ai:OpenShift version'), isRequired: true },
        react_1.default.createElement(react_core_1.Dropdown, Object.assign({}, field, { id: `${fieldId}-dropdown`, shouldFocusToggleOnSelect: true, isOpen: isOpen, onSelect: onSelect, onOpenChange: () => setOpen(!isOpen), toggle: dropdownToggle }), dropdownGroup),
        helperText && (react_1.default.createElement(react_core_1.FormHelperText, null,
            react_1.default.createElement(react_core_1.HelperText, null,
                react_1.default.createElement(react_core_1.HelperTextItem, { variant: "default" }, helperText)))),
        showReleasesLink && (react_1.default.createElement(ExternalLink_1.default, { href: `${window.location.origin}/${config_1.OCP_RELEASES_PAGE}` },
            react_1.default.createElement("span", { "data-ouia-id": "openshift-releases-link" }, t('ai:Learn more about OpenShift releases'))))));
};
exports.OpenShiftVersionDropdown = OpenShiftVersionDropdown;
//# sourceMappingURL=OpenShiftVersionDropdown.js.map